export enum Title {
  productPartners = "Product Partners",
}

export const titles = {
  productPartners: false,
};

interface IRow {
  children: React.ReactNode;
  title: string;
  isShow?: boolean;
  onToggle?: () => void;
}

export const Row = ({ children, title, isShow = false, onToggle }: IRow) => {
  return (
    <div className="border-t border-solid border-gray-200 dark:border-gray484848">
      <div
        className="py-4 flex items-center justify-between cursor-pointer hover:bg-gray-50 dark:hover:bg-white20"
        onClick={onToggle}
      >
        <div className="font-bold">{title}</div>
      </div>

      {isShow && <div className="pb-6">{children}</div>}
    </div>
  );
};
